import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from 'src/components/molecules/dialog';
import { useDeleteSpaceGroup } from 'src/features/space-groups/api/hooks/use-delete-space-group';
import { SpaceGroupsActionsSlotPayload } from '../../molecules/space-groups-table-row';

interface Props extends DialogActions {
  selectedSpaceGroup: SpaceGroupsActionsSlotPayload | null;
}

export const DeleteSpaceGroupDialog = ({
  open,
  onCancel,
  selectedSpaceGroup,
}: Props) => {
  const { t } = useTranslation(['spaceGroups', 'common']);

  const { mutate: deleteSpaceGroup, isPending: isDeletingSpaceGroup } =
    useDeleteSpaceGroup(onCancel);

  return (
    <Dialog
      variant="warning"
      open={open}
      title={t('spaceGroups:common.deleteGroupDialog.title')}
      onCancel={onCancel}
      cancelButtonText={t('common:button.no')}
      confirmButtonText={t(
        'spaceGroups:common.deleteGroupDialog.confirmButtonText',
      )}
      onConfirm={() => deleteSpaceGroup(selectedSpaceGroup?.token ?? '')}
      isConfirmButtonSubmitting={isDeletingSpaceGroup}>
      <Typography variant="body2">
        {t('spaceGroups:common.deleteGroupDialog.message', {
          name: selectedSpaceGroup?.name,
        })}
      </Typography>
    </Dialog>
  );
};
